/**
 * Takes following arguments & returns an object with play & pause methods
 * @param {string} url 
 * @param {number} volume 
 * @param {loop} loop 
 * @returns {object}
 */
export const audioPlayer = (url: string, volume: number, loop: boolean) => {
  const audio = new Audio(url);
  audio.loop = loop;
  audio.volume = volume;

  return {
    play: () => audio.play(),
    pause: () => {
      audio.pause();
      audio.src = "";
      audio.load();
      audio.removeAttribute("src");
    },
    setDelayedAutoPause: (waitTime = 500) => {
      new Promise((res, rej) => {
        setTimeout(() => {
          audio.pause();
        }, waitTime);
  
        res(`Audio auto paused after ${waitTime}`);
      })
    }
  }
}
